import pick from 'lodash/pick'

import { DeductionComponent } from '@modules-deprecated/app/taxrates/types'

import { DeductionComponentForm } from '../../../../types/deductionComponentForm'

export const removeIdAndTaxRateId = (deductionComponent: DeductionComponent): DeductionComponentForm => {
  return pick(deductionComponent, ['share', 'source', 'accountId', 'accountSystemRole'])
}
